var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.16699V17.5C17.5 18.4167 16.7497 19.167 15.833 19.167H6.6582C5.7416 19.1669 5 18.4166 5 17.5L5.00879 5.83301C5.00896 4.91649 5.75043 4.16699 6.66699 4.16699H12.5L17.5 9.16699ZM11.25 6.66699C9.64101 6.66699 8.33307 7.99122 8.33301 9.62109C8.33299 10.2315 8.52012 10.827 8.86816 11.3252C9.21636 11.8234 9.709 12.2004 10.2773 12.4033V14.5459H8.33301V16.5156H10.2773V17.5H12.2227V12.4033C12.791 12.2004 13.2836 11.8234 13.6318 11.3252C13.9799 10.827 14.167 10.2315 14.167 9.62109C14.1669 7.99122 12.859 6.66699 11.25 6.66699ZM13.333 0.833008V2.5H3.33301V14.167H1.66699V2.5C1.66699 1.58344 2.41649 0.833185 3.33301 0.833008H13.333ZM11.25 8.63672C11.7847 8.63672 12.2226 9.07948 12.2227 9.62109C12.2227 10.1628 11.7847 10.6064 11.25 10.6064C10.7153 10.6064 10.2773 10.1628 10.2773 9.62109C10.2774 9.07948 10.7153 8.63672 11.25 8.63672Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyPassword);
export default __webpack_public_path__ + "static/media/icon-copy-password.69e316e91e03aa867c9f34b20d247e2f.svg";
export { ForwardRef as ReactComponent };